import type { IExercise } from '../exercises';

export const HOME_EPISODE_04_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-home-04-01",
    "name": "弹力带绕肩",
    "bodyPart": "warmup",
    "equipment": "resistance-band",
    "subCategory": "general",
    "tips": ["弹力带两端握手上，直臂前后绕肩", "动作缓慢流畅，激活肩关节活动度"],
    "sets": 2,
    "reps": "15",
    "rpe": 3,
    "restSeconds": 30,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "source": "居家训练 · 第4期",
    "demoUrl": "/media/collections-20261008/demos/mobile-2950fb5523d60d793c740576.mp4",
    "videoUrl": "/media/collections-20261008/videos/1f964844bc0e3b64c1355e5b.mp4",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-home-04-02",
    "name": "俯卧Y字举",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "shoulder",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 2,
    "reps": "15",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["三角肌后束", "斜方肌下部"],
    "demoUrl": "/media/collections-20261008/demos/mobile-8cbb398adff5b64c3716fdb9.mp4",
    "videoUrl": "/media/collections-20261008/videos/7c044d5c3655d9077a468589.mp4",
    "source": "居家训练 · 第4期",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-home-04-03",
    "name": "坐姿哑铃推举",
    "bodyPart": "shoulders",
    "equipment": "dumbbell",
    "subCategory": "front-deltoid",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 4,
    "reps": "8-12",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["三角肌前束", "三角肌中束"],
    "demoUrl": "/media/collections-20261008/demos/mobile-429575a72dc8a86c6e9d0956.mp4",
    "videoUrl": "/media/collections-20261008/videos/9896d83850028b5d68533148.mp4",
    "source": "居家训练 · 第4期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-home-04-04",
    "name": "哑铃前平举",
    "bodyPart": "shoulders",
    "equipment": "dumbbell",
    "subCategory": "front-deltoid",
    "tips": ["前平举刺激前束", "交替或双手"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/reviewed-cec4f72f20db6a5e6212b14b.mp4",
    "videoUrl": "/media/collections-20261008/videos/82776fcc2991d65ba7d808cd.mp4",
    "targetMuscles": ["三角肌前束"],
    "difficulty": "intermediate",
    "source": "居家训练 · 第4期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-home-04-05",
    "name": "哑铃侧平举",
    "bodyPart": "shoulders",
    "equipment": "dumbbell",
    "subCategory": "medial-delt",
    "tips": ["肘微屈，侧抬与肩齐平", "控制下放"],
    "sets": 3,
    "reps": "15",
    "rpe": 7,
    "restSeconds": 45,
    "isBodyweight": false,
    "source": "居家训练 · 第4期",
    "demoUrl": "/media/collections-20261008/demos/reviewed-2aa79bc51219323efaf8e8db.mp4",
    "videoUrl": "/media/collections-20261008/videos/a1ebdd94560a8c8e42066620.mp4",
    "targetMuscles": ["三角肌中束"],
    "difficulty": "intermediate",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-home-04-06",
    "name": "坐姿哑铃俯身飞鸟",
    "bodyPart": "shoulders",
    "equipment": "dumbbell",
    "subCategory": "rear-deltoid",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["三角肌后束", "斜方肌下部"],
    "demoUrl": "/media/collections-20261008/demos/reviewed-d914d679312877a9913282aa.mp4",
    "videoUrl": "/media/collections-20261008/videos/531a386247d11d153a2062bc.mp4",
    "source": "居家训练 · 第4期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-home-04-07",
    "name": "哑铃弯举",
    "bodyPart": "arms",
    "equipment": "dumbbell",
    "subCategory": "biceps",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["肱二头肌", "肱肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-1d538fda9a2b00b00fac60c7.mp4",
    "videoUrl": "/media/collections-20261008/videos/45bacd7448944c06a51ea42a.mp4",
    "source": "居家训练 · 第4期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-home-04-08",
    "name": "站姿颈后臂屈伸",
    "bodyPart": "arms",
    "equipment": "dumbbell",
    "subCategory": "triceps",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["肱三头肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-25d57c7daecb82dfe9c1a831.mp4",
    "videoUrl": "/media/collections-20261008/videos/f6a05742ae32c4f6a2e68e8c.mp4",
    "source": "居家训练 · 第4期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
];
